/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { Button } from "@cd2/components"
import { IxRef } from "@cd2/tools/build/es6"

interface IProps {
  children?: React.ReactNode
  disabled?: boolean
  className?: string

  onClick?(e?: any): void
  xRef?: IxRef<HTMLDivElement>
}

export function CancelButton({ xRef, children = "Cancel", onClick, disabled, className }: IProps) {
  return (
    <div
      ref={xRef}
      css={css`
        display: inline-block;
      `}
    >
      <Button
        className={className}
        buttonColor="#999"
        buttonStyle="outline"
        color="#666"
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </Button>
    </div>
  )
}
